import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'src/components/Buttons/Button';
import { cioTrackEvent } from 'src/modules/cio';
import { useRoute } from 'src/router/hooks/useRoute';

export const Controls = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ROUTE } = useRoute();

  return (
    <div className="flex flex-col gap-2">
      <Button
        mode="button-primary"
        onClick={() => {
          cioTrackEvent('deposit_btn_click', 'account');
          navigate(ROUTE.ACCOUNT_DEPOSIT.get());
        }}>
        {t('general.deposit')}
      </Button>
      <Button
        mode="button-secondary"
        onClick={() => {
          cioTrackEvent('withdrawal_btn_click', 'account');
          navigate(ROUTE.ACCOUNT_WITHDRAWAL.get());
        }}>
        {t('sortType.withdrawal')}
      </Button>
    </div>
  );
};
